import { init as barbaInit } from "./mybarba.js";
import { init as nl__init, collection_filters_call } from "./init.js";
import { init as lenis } from "./parts/lenis.js";

barbaInit();
lenis();

jQuery(function () {  
    //console.log('jQuery first time');
	nl__init();

	jQuery(document).on("click", "a[data-fltr-type]", function (e) {
		e.preventDefault();

		jQuery(this).toggleClass("used-filter");

		let data_filters = {};

		jQuery(this)
			.closest(".collection-filters__filters")
			.find(".used-filter[data-fltr-type]")
			.each(function () {
				if (!(jQuery(this).attr("data-fltr-type") in data_filters)) {
					data_filters[jQuery(this).attr("data-fltr-type")] = [];
				}

				let data_value = ( "input" === jQuery(this).prop("tagName").toLowerCase() ) ? jQuery(this).val() : jQuery(this).attr("data-fltr-id");

				data_filters[jQuery(this).attr("data-fltr-type")].push(data_value);
			});

		collection_filters_call(data_filters, this);

		return false;
	});

	jQuery(document).on("change", "input[data-fltr-type]", function (e) {
		e.preventDefault();

		jQuery(this).toggleClass("used-filter");

		let data_filters = {};

		jQuery(this)
			.closest(".collection-filters__filters")
			.find(".used-filter[data-fltr-type]")
			.each(function () {
				if (!(jQuery(this).attr("data-fltr-type") in data_filters)) {
				data_filters[jQuery(this).attr("data-fltr-type")] = [];
				}

				let data_value =
				"input" === jQuery(this).prop("tagName").toLowerCase()
					? jQuery(this).val()
					: jQuery(this).attr("data-fltr-id");

				data_filters[jQuery(this).attr("data-fltr-type")].push(data_value);
			});

		collection_filters_call(data_filters, this);

		return false;
	});

	jQuery(document).on("change", "select[data-fltr-type]", function (e) {
		e.preventDefault();

		if ( jQuery(this).val() !== "" ) {
			jQuery(this).addClass("used-filter");
		} else {
			jQuery(this).removeClass("used-filter");
		}

		let data_filters = {};

		jQuery(this)
			.closest(".collection-filters__filters")
			.find(".used-filter[data-fltr-type]")
			.each(function () {
				if (!(jQuery(this).attr("data-fltr-type") in data_filters)) {
					data_filters[jQuery(this).attr("data-fltr-type")] = [];
				}

				const tagName_filter = jQuery(this).prop("tagName").toLowerCase();

				let data_value =
					"input" === tagName_filter || "select" === tagName_filter
						? jQuery(this).val()
						: jQuery(this).attr("data-fltr-id");

				data_filters[jQuery(this).attr("data-fltr-type")].push(data_value);
			});

		collection_filters_call(data_filters, this);

		return false;
	});
      
});